module.exports = __webpack_public_path__ + "media/music/piano_6-e2536e51.mp3";